"use client";

// src/slider.tsx
import { cn } from "@momo/utils";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { jsx, jsxs } from "react/jsx-runtime";
var Slider = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    SliderPrimitive.Root,
    {
      className: cn("relative flex w-full touch-none select-none items-center", className),
      ...rest,
      children: [
        /* @__PURE__ */ jsx(SliderPrimitive.Track, { className: "bg-primary/20 relative h-1.5 w-full grow overflow-hidden rounded-full", children: /* @__PURE__ */ jsx(SliderPrimitive.Range, { className: "bg-primary absolute h-full" }) }),
        /* @__PURE__ */ jsx(SliderPrimitive.Thumb, { className: "border-primary/50 bg-background focus-visible:ring-ring block size-4 rounded-full border shadow transition-colors focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:opacity-50" })
      ]
    }
  );
};

export {
  Slider
};
